import { ImportCSVQrCodeIssues } from '@components/process-import-csv/process-import-csv.type';
import { qrCodeUrlSchemeValidator } from '@utils/validations/constants';
import { emailValidator } from '@utils/validations/constants';
import { isQrCodeDateLike } from '@utils/validations/is-qr-code-date-like';
import { isQrCodeHostLike } from '@utils/validations/is-qr-code-host-like';

// Dates, e-mail addresses and URLs are never valid access codes, but they are reported here
// rather than as a column error on purpose: a column error disables the submit, and a false
// positive would leave the operator unable to import at all. The backend rejects them either
// way and the process page lists them as failed rows.
const isNotAQrCode = (value: string) =>
  isQrCodeDateLike(value) ||
  emailValidator.test(value) ||
  qrCodeUrlSchemeValidator.test(value) ||
  isQrCodeHostLike(value);

export const createQrCodeIssueLists = (columns: string[][], qrCodeIndex: number): ImportCSVQrCodeIssues => {
  const emptyRows: number[] = [];
  const duplicateRows: number[] = [];
  const invalidRows: number[] = [];
  const qrCodeValues = new Set<string>();

  if (qrCodeIndex !== -1) {
    columns[qrCodeIndex].forEach((value, rowIndex) => {
      const rowNumber = rowIndex + 1;
      const trimmedValue = value.trim();

      if (!trimmedValue) {
        emptyRows.push(rowNumber);
        return;
      }

      if (qrCodeValues.has(value)) {
        duplicateRows.push(rowNumber);
      } else {
        qrCodeValues.add(value);
      }

      // Independent of the duplicate check: a repeated bad value is still a bad value on every
      // row it appears, and the two warnings are reported separately.
      if (isNotAQrCode(trimmedValue)) invalidRows.push(rowNumber);
    });
  }

  return {
    emptyRows,
    duplicateRows,
    invalidRows,
  };
};
